import _process from "process";
var exports = {};
var process = _process;
const isWindows = typeof process === "object" && process && process.platform === "win32";
exports = isWindows ? {
  sep: "\\"
} : {
  sep: "/"
};
export default exports;